import base from './base.repository';
export default {
    ...base,
    loadDutiesByClient(clientId, filters, page){
        this.get(`duties?client=${clientId}&name=${filters.name}&page=${page}`);
        return this;
    },
    //Lista de duties generales y del punto de trabajo (cliente) en el que este el vigilante
    loadDutiesClientAndGeneral(clientId, filters, page){
        const params = {...filters, page, client: clientId};
        this.get(`duties/general-and-specific-client${this.querify(params)}`);
        return this;
    },
    //cargar solo las consignas especificas y no aprobadas
    loadDutiesSpecificsAndUnapproved(page){
        this.get(`duties/specifics-and-unapproved?page=${page}`);
        return this;
    },
    loadDuties(filters, page){
        const params = {...filters, page};
        this.get(`duties${this.querify(params)}`);
        return this;
    },
    //cargar todas las consignas (para la asignación de consignas)
    loadAllDuties(page){
        this.get(`duties/bank?page=${page}`);
        return this;
    },
    //cargar las consignas generales y especificas aprobadas del cliente en el punto de trabajo
    loadGeneralsAndSpecificsApproved(clientId, filters, page){
        const params = {...filters, page, client: clientId};
        this.get(`duties/specifics-and-approved${this.querify(params)}`);
        return this;
    },  
    saveDuty(duty) {
        this.post(`duties`, duty);
        return this;
    },
    updateDuty(duty, id) {
        this.put('duties/' + id, duty);
        return this;
    },
    deleteDuty(id){
        this.delete('duties/'+id);
        return this;
    },
    approveDuty(id, payload){
        this.post('duties/'+id+'/approve', payload);
        return this;
    },
    assignClient(payload){
        this.post('duties/assign-client', payload)
        return this;
    },
    unassignClient(payload){
        this.post('duties/unassign-client', payload)
        return this;
    }
}